export const PAYMENT_CONFIG = {
  CREATE_ORDER_URL: 'https://7yyduvtrfgzkvhtgthv3omirqe0ydkci.lambda-url.ap-south-1.on.aws/',
  VERIFY_ORDER_URL: 'https://ann5fqysl4dwks7pl4yoourfv40duqsd.lambda-url.ap-south-1.on.aws/',
  CURRENCY: 'INR',
  DEFAULT_AMOUNTS: [500, 1000, 2500, 5000],
  ORG_NAME: 'Slum Soccer',
};
